import { render, staticRenderFns } from "./related.vue?vue&type=template&id=118bd325&scoped=true&lang=pug&"
import script from "./related.vue?vue&type=script&lang=js&"
export * from "./related.vue?vue&type=script&lang=js&"
import style0 from "./related.vue?vue&type=style&index=0&id=118bd325&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118bd325",
  null
  
)

/* custom blocks */
import block0 from "~/lang/blog?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fubuntu%2Fnuxt%2Fbonkers%2Freleases%2F20230320152633%2Fcomponents%2Fsite%2Fblog%2Farticle%2Frelated.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WidgetsImage: require('/home/ubuntu/nuxt/bonkers/releases/20230320152633/components/widgets/image.vue').default})
